import React from 'react';
import { Link } from 'react-router-dom';
export default function MoreInfo() {
	return (
		<div className='ml-0 lg:pr-4'>
			<div className='max-w-xl text-base leading-7 text-gray-700 lg:max-w-lg'>
				<h2 className='mt-16 mb-10 text-2xl font-bold tracking-tight text-gray-900'>
					Specific questions about your blinds?{' '}
					<Link
						className='text-primary-500 hover:text-primary-400'
						to='/contact'
					>
						Shoot us a message
					</Link>
				</h2>
			</div>
		</div>
	);
}
